// const UserTab = () => {
//   return <div>UserTab</div>;
// };
// export default UserTab;

import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, MenuItem,Select, Menu,Typography, IconButton, FormControl, Button,} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useParams } from "react-router-dom";
import SearchBar from "../../SearchBar";
import { BsPerson } from "react-icons/bs";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import "../../../App.css";
import ClientAddUser from "./ClientAddUser";
import PortalUserComponent from "./PortalUser";
import { deleteParams, fetchEntityById, newFilterEntities} from "../../../apis/apiService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  useFetchAddportalUserQuery,
  useFetchClientsShowUsersQuery,
  useFetchPortalUserQuery,
} from "../../../slice/logdetailSlice";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import { useTheme } from "../../../ThemeContext";
import {CommonDeleteUsers,} from "../../common/CommonDelete";


const UserFilterComponent = ({ onApply, onClear, onCancel }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      email: "",
      user: "",
      role: "",
      profile: "",
      invitationStatus: "",
    },
  });
  const portalUsers = useSelector(
    (state) => state.selectOptions.PortalUserNameOptions
  );
  const userDetails = portalUsers.map((user) => {
    // Access nested data object
    const { data } = user;
    // //console.log()("userss :", user);
    if (!data) {
      console.warn("No data object found for user:", user);
      return null;
    }
    const {
      user_id,
      email,
      designation,
      role,
      name,
      image_url,
      rate_per_hour,
      is_accept_invitation,
    } = data;

    // //console.log()("User Details:");
    // //console.log()("ID:", user_id);
    // //console.log()("Name:", name);
    // //console.log()("Email:", email);
    // //console.log()("Designation:", designation);
    // //console.log()("Role:", role);
    // //console.log()("Image URL:", image_url);
    return {
      user_id,
      name,
      email,
      designation,
      role,
      image_url,
      rate_per_hour,
      is_accept_invitation,
    };
  });
  // //console.log()("user_detail :", userDetails);

  const onSubmit = async (data) => {
    const requestedData = {
      email: data.email,
      user: data.user,
      role: data.role,
      designation: data.profile,
      invitation_status: data.invitationStatus,
    };
    setLoading(true);
    try {
      const response = await newFilterEntities("projects/users/filter",id, requestedData);
      // //console.log()("filtered_response in filter page :", response.data);

      if (response?.data) {
        onApply(response.data);
        toast.success(response.message);
        onClear();
        onCancel();
      }
    } 
    catch (err) {
      toast.error(err.message);
      console.error(err);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset({
      email: "",
      user: "",
      role: "",
      profile: "",
      invitationStatus: "",
    });
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>

        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                <div className="col-md-12">
                  <Controller
                    control={control}
                    name="email"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <label htmlFor="email">Email</label>
                        <Select
                          // label="email"
                          id="email"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select email</span>
                            )
                          }
                          {...field}
                          IconComponent={ExpandMore}
                        >
                          {userDetails.map((userDatas, index) => (
                            <MenuItem key={index} value={userDatas.email}>
                              {userDatas.email}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="user" className="form-label">
                    User
                  </label>
                  <Controller
                    control={control}
                    name="user"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="user-label"
                          id="user"
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              userDetails.find(
                                (namelist) => namelist.user_id === selected
                              )?.name
                            ) : (
                              <span className=" lightText">Select name</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {userDetails.map((userDatas, index) => (
                            <MenuItem key={index} value={userDatas.user_id}>
                              {userDatas.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="role" className="form-label">
                    Role
                  </label>
                  <Controller
                    control={control}
                    name="role"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="role-label"
                          id="role"
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select role</span>
                            )
                          }
                        >
                          <MenuItem value="Admin">Admin</MenuItem>
                          <MenuItem value="Manager">Manager</MenuItem>
                          <MenuItem value="Employee">Employee</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="row paddingBtn  mb-3">
                <div className="col-md-6">
                  <label htmlFor="profile" className="form-label">
                    Designation
                  </label>
                  <Controller
                    control={control}
                    name="profile"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="profile-label"
                          id="profile"
                          {...field}
                          IconComponent={ExpandMore} // Add the custom icon here
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">
                                Select designation
                              </span>
                            )
                          }
                        >
                          <MenuItem value="Froentend">Froentend</MenuItem>
                          <MenuItem value="Backend">Backend</MenuItem>
                          <MenuItem value="Tester">Tester</MenuItem>
                          <MenuItem value="Client">Client</MenuItem>
                          <MenuItem value="Designer">Designer</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="invitationStatus" className="form-label">
                    Invitation status
                  </label>
                  <Controller
                    control={control}
                    name="invitationStatus"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="invitationStatus-label"
                          id="invitationStatus"
                          IconComponent={ExpandMore} // Add the custom icon here
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select status</span>
                            )
                          }
                        >
                          <MenuItem value="Accepted">Accepted</MenuItem>
                          <MenuItem value="Not Accepted">Not Accepted</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="d-flex position-absolute bottom-0 w-100 bg-white p-2  justify-content-start  gap-3 mt-5">
                <button type="submit" className="me-3 add_btn">
                  {loading ? "Applying..." : " Apply"}
                </button>
                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const AddUserComponent = ({
  onCancel,
  onApply,
  onClear,
  // showUsers,
  showClients,
}) => {
  return (
    <Box sx={{ padding: 2, height: "100%" }} className="bg-white">
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <IconButton onClick={onCancel}>
          <ArrowBackIosIcon className="text-rgba-gray" sx={{ fontSize: 15 }} />
          <Typography
            variant="h1"
            sx={{
              fontWeight: "bold",
              marginLeft: 1,
              color: "black",
              fontSize: "15px",
            }}
          >
            Add Users
          </Typography>
        </IconButton>
      </Box>

      <Box
        sx={{
          backgroundColor: "var(--cell-bg-color)",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
        }}
      >
        <div>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item pe-4" role="presentation">
              <button
                className="active text-rgba-gray R_btn"
                id="Comments-tab"
                data-bs-toggle="tab"
                data-bs-target="#Comments"
                type="button"
                role="tab"
                aria-controls="Comments"
                aria-selected="true"
              >
                Portal user
              </button>
            </li>

            <li className="nav-item pe-4" role="presentation">
              <button
                className="text-rgba-gray R_btn"
                id="StatusTimeline-tab"
                data-bs-toggle="tab"
                data-bs-target="#StatusTimeline"
                type="button"
                role="tab"
                aria-controls="StatusTimeline"
                aria-selected="false"
              >
                Client User
              </button>
            </li>
          </ul>

          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="Comments"
              role="tabpanel"
              aria-labelledby="Comments-tab"
            >
              {/* <ProjectComments projectDetail={projectDetail} /> */}
              <PortalUserComponent
                onCancel={onCancel}
                // showUsers={showUsers}
                onApply={onApply}
                onClear={onClear}
              />
            </div>

            <div
              className="tab-pane fade"
              id="StatusTimeline"
              role="tabpanel"
              aria-labelledby="StatusTimeline-tab"
            >
              {/* <ProjectStatusTimeline /> */}
              <ClientAddUser
                onCancel={onCancel}
                onApply={onApply}
                onClear={onClear}
                showClients={showClients}
              />
            </div>

            <div
              className="tab-pane fade"
              id="ActivityStream"
              role="tabpanel"
              aria-labelledby="ActivityStream-tab"
            >
              {/* <ActivityStream /> */}
            </div>
          </div>
        </div>
        {/* Table */}
      </Box>
    </Box>
  );
};

const ClientUsers = () => {
  const [search, setSearch] = useState("");
  const [projects, setProjects] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]); // Track selected users
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user in task:", login_user);
  const { role: login_user_role } = login_user;
  // //console.log()("login_user role in task:", login_user_role);
  const { id } = useParams();
  // //console.log()("user show id :", id);
  const project_id = localStorage.getItem("project_id");
  const {
    data,
    isLoading,
    refetch: portal_client_show_refetch,
  } = useFetchClientsShowUsersQuery(project_id);
  const { refetch: client_refetch } = useFetchAddportalUserQuery({
      id: project_id,
      type: "client",
    });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  useEffect(() => {
    if (data) {
      const userDatas = data.map((user) => ({
        ...user,
        id: user.user_id,
      }));
      setProjects(userDatas);
    } else {
      setProjects([]); // Ensure projects is never undefined
    }
  }, [data]);

  // Ensure filteredUsers is always an array
  const filteredUsers = projects?.length
    ? projects.filter(
        (user) =>
          user?.user_name?.toLowerCase().includes(search.toLowerCase()) ||
          user?.email?.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  // Handle checkbox selection
  const handleUserSelect = (userId, isSelected) => {
    setSelectedUsers((prev) =>
      isSelected ? [...prev, userId] : prev.filter((id) => id !== userId)
    );
  };

  const columns = [
    ...(login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            field: "actions",
            headerName: "Action",
            width: 100,
            renderCell: (params) => (
              <Box display="flex" alignItems="center">
                <IconButton
                  onClick={(event) => handleMenuOpen(event, params.row)}
                >
                  <MoreVertIcon sx={{ color: "black" }} />
                </IconButton>
              </Box>
            ),
          },
        ]
      : []),
    { field: "id", headerName: "ID", width: 200 },
    {
      field: "user_name",
      headerName: "User Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Box>
            <span>{params.row.user_name}</span>
          </Box>
        );
      },
    },
    { field: "email", headerName: "Email", width: 300 },
    // { field: "role", headerName: "Role", width: 200 },
    // { field: "designation", headerName: "Profile", width: 200 },
    // {
    //   field: "is_accept_invitation",
    //   headerName: "InvitationStatus",
    //   width: 200,
    // },
  ];
  // Open Menu
  const handleMenuOpen = (event, userId) => {
    console.log("client_user_list :", userId);

    setAnchorEl(event.currentTarget);
    setSelectedUserId({ user_id: userId.user_id, name: userId.user_name });
  };

  const handleDeleteClient = async () => {
    try {
      const response = await deleteParams("projects/users/delete", project_id, {
        user_id: selectedUserId,
      });
      toast.success(response.message);
      client_refetch();
      portal_client_show_refetch();
    } 
    catch (err) {
      console.error("Error deleting user:", err);
      toast.error(err.message);
    } 
    finally {
      handleMenuClose();
    }
  };

  // Close Menu
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC", height: "100%" }}>
      <DataGrid
        rows={projects}
        columns={columns}
        autoHeight
        disableSelectionOnClick
        // hideFooter
        getRowId={(row) => row.user_id}
        loading={isLoading}
        pagination
        paginationModel={paginationModel}
        pageSizeOptions={[25, 50, 75, 100]}
        onPaginationModelChange={setPaginationModel}
        slots={{ noRowsOverlay: CustomNoRowsOverlay }}
      />
      {/* Menu with Actions */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <CommonDeleteUsers
          url="projects/users/delete"
          refetchList={client_refetch}
          refetchListTwo={portal_client_show_refetch}
          id={project_id}
          user_id={selectedUserId?.user_id}
          statusName={selectedUserId?.name}
          name="Client"
          handleListClose={handleMenuClose}
        />
      </Menu>
    </Box>
  );
};

const UserTab = () => {
  const { isDarkMode } = useTheme();
  const [projects, setProjects] = useState([]);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState({});
  const [filter, setFilter] = useState("portal_users");
  const [searchTerm, setSearchTerm] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [loading, setLoading] = useState(false);

  const project_id = localStorage.getItem("project_id");
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user || {};
  const { id } = useParams();
  const [showProject, setShowProject] = useState(false);
  const { reset } = useForm();
  // Queries
  const {
    data: portalData,
    refetch: refetchPortalUsers,
    isLoading: portalLoading,
  } = useFetchPortalUserQuery(project_id);

  const {
    data: clientData,
    isLoading: clientLoading,
  } = useFetchClientsShowUsersQuery(project_id);

  const showClients = async () => {
    const response = await fetchEntityById("projects/client/show", project_id);
    if (response?.data) {
      setProjects(
        response.data.map((user, index) => ({
          ...user,
          id: user.user_id || index,
        }))
      );
    } else {
      setProjects([]);
    }
  };

  const showUsers = () => {
    if (portalData?.data) {
      const mapped = portalData.data.map((user, index) => ({
        ...user,
        id: user.user_id || index,
      }));
      setProjects(mapped);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setProjects([]);
      setLoading(true);
      if (filter === "portal_users") {
        showUsers();
      } else {
        await showClients();
      }
      setLoading(false); // End loading after data is set
    };
    loadData();
  }, [filter, portalData, clientData]);

  const fetchSearchedUsers = async (searchQuery) => {
    // setLoading(true);
    try {
      const response = await newFilterEntities(
        filter === "portal_users"
          ? "projects/users/show"
          : "projects/client/show",
        project_id,
        // { searchText: searchQuery }
        { searchText: searchQuery.trim() }
      );

      if (response?.data) {
        const transformed = response.data.map((user, index) => ({
          ...user,
          id: user.user_id || index,
        }));
        setProjects(transformed);
      }
       else {
        setProjects([]);
      }
    } 
    catch (err) {
      console.error("Search error:", err);
      setProjects([]);
    // } finally {
    //   setLoading(false);
    }
  };

  // const handleSearchChange = async (e) => {
  //   const value = e.target.value.toLowerCase();
  //   setSearchTerm(value);
  //   if (value.trim()) await fetchSearchedUsers(value);
  //   else filter === "portal_users" ? refetchPortalUsers() : showClients();
  // };
  const handleSearchChange = async (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    // if (value.trim()) {
     if (value) {
      await fetchSearchedUsers(value);
    } 
    else {
      setLoading(true);
      filter === "portal_users" ? showUsers() : await showClients();
      setLoading(false);
    }
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask({ id: row.user_id, name: row.user_name });
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleShowProject = () => setShowProject(true);
  const commonActionsColumn =
    login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            field: "actions",
            headerName: "Action",
            width: 100,
            renderCell: (params) => (
              <Box display="flex" alignItems="center">
                <IconButton onClick={(e) => handleMenuOpen(e, params.row)}>
                  <MoreVertIcon />
                </IconButton>
              </Box>
            ),
          },
        ]
      : [];

  const portalColumns = [
    ...commonActionsColumn,
    { field: "user_name", headerName: "User Name", width: 200 },
    { field: "email", headerName: "Email", width: 300 },
    { field: "role", headerName: "Role", width: 200 },
    { field: "designation", headerName: "Profile", width: 200 },
    {
      field: "is_accept_invitation",
      headerName: "InvitationStatus",
      width: 200,
    },
  ];


  const clientColumns = [
    ...commonActionsColumn,
    { field: "id", headerName: "ID", width: 200 },
    { field: "user_name", headerName: "User Name", width: 200 },
    { field: "email", headerName: "Email", width: 300 },
  ];

  const columns = filter === "portal_users" ? portalColumns : clientColumns;

  const filterOptions = [
    { label: "Portal Users", value: "portal_users" },
    { label: "Client Users", value: "client_users" },
  ];

  return (
    <div style={{ padding: "9px 16px" }} className="bg-white">
      <Offcanvas show={showProject} placement="end" style={{ width: "80%" }}>
        <Offcanvas.Body className="p-0">
          <AddUserComponent
            onApply={(filters) =>
              setProjects(/* filtered data based on `filters` */)
            }
            // showUsers={showUsers}
            showClients={showClients}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}

      {/* <div className="d-flex justify-content-between pb-2">
        <FormControl className="pb-2">
          <Select value={filter} onChange={(e) => setFilter(e.target.value)}> */}

      <Box
        className="row align-items-center"
        sx={{
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "12px 16px",
          marginBottom: "9px",
          backgroundColor: isDarkMode ? "transparent" : "#fff",
          mx: 0,
        }}
      >
        <div className="col-12 col-lg-2 col-md-4" style={{ paddingLeft: 0 }}>
          <FormControl size="small" sx={{ width: "auto", minWidth: "135px" }}>
            <Select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              size="small"
            >
              {filterOptions.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* <div className="d-flex gap-3 align-items-center"> */}
        <div className="col-12 col-lg-10 col-md-8 d-flex flex-wrap justify-content-md-end gap-2 align-items-center" style={{ paddingRight: 0 }}>
          <SearchBar
            placeholder="Search user"
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
          />
          {(login_user_role === "MANAGER" || login_user_role === "ADMIN") && (
            <Button
              className="AddButton rounded me-1 ms-2"
              onClick={handleShowProject}
              startIcon={<BsPerson  />}
            >
              Add Users
            </Button>
          )}
        </div>
      {/* </div> */}
    </Box>

      <Box style={{ width: "100%" }}>
        <DataGrid
          rows={projects}
          columns={columns}
          autoHeight
          disableSelectionOnClick
          getRowId={(row) => row.id}
          loading={loading || portalLoading || clientLoading}
          pagination
          paginationModel={paginationModel}
          pageSizeOptions={[25, 50, 75, 100]}
          onPaginationModelChange={setPaginationModel}
          slots={{ noRowsOverlay: CustomNoRowsOverlay }}
        />
      </Box>

      {/* Action Menu */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
      >
        <CommonDeleteUsers
          url={"projects/users/delete"}
          refetchList={
            filter === "portal_users" ? refetchPortalUsers : showClients
          }
          id={project_id}
          user_id={selectedTask?.id}
          statusName={selectedTask?.name}
          name="User"
          handleListClose={handleMenuClose}
        />
      </Menu>
    </div>
  );
};
export default UserTab;
